import { ApiBase } from '@bymason/api-base';
import { CmsNewBuildView } from './types';

export * from './types';

class NewBuildViewCmsApi extends ApiBase {
  private static instance: NewBuildViewCmsApi;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A NewBuildViewCmsApi instance
   */
  public static getInstance(): NewBuildViewCmsApi {
    if (!NewBuildViewCmsApi.instance) {
      NewBuildViewCmsApi.instance = new NewBuildViewCmsApi();
    }

    return NewBuildViewCmsApi.instance;
  }

  /**
   * Gets CMS content specific to the Select-Device-To-Build view.
   * @returns either a CmsSelectDeviceToBuild model or void
   */
  public async getViewContent() {
    //
    // TODO: Setup endpoint calls to get content from Strapi CMS
    //
    const dataResponse = await Promise.resolve<CmsNewBuildView>({
      helpTopic: 'new-build',
    });

    return dataResponse;
  }
}

export const newBuildViewCmsApi = NewBuildViewCmsApi.getInstance();
